/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Pagination/theme';

export const PaginationTheme = theme;
